import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../lib/api';

export default function UnsubscribePage() {
  const { leadId, type } = useParams();
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const endpoint = type === 'partner'
      ? `/affiliates/unsubscribe/${leadId}`
      : `/submissions/unsubscribe/${leadId}`;
    api.post(endpoint)
      .then(() => setStatus('done'))
      .catch(() => setStatus('error'));
  }, [leadId, type]);

  return (
    <div style={{ minHeight: '100vh', background: '#FAFBFC', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ maxWidth: 480, textAlign: 'center' }}>
        {status === 'processing' && (
          <p style={{ color: '#64748B', fontSize: 16 }}>Processing...</p>
        )}
        {status === 'done' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16, color: '#16A34A' }}>&#10003;</div>
            <h1 style={{ color: '#1B2B4B', fontSize: 24, fontWeight: 700, marginBottom: 12 }}>You've been unsubscribed</h1>
            <p style={{ color: '#64748B', fontSize: 15, lineHeight: 1.6, marginBottom: 28 }}>
              You won't receive any more follow-up emails from ClearSeg. If you change your mind, you can always start a new study at any time.
            </p>
            <Link to="/" style={{ color: '#2563EB', fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>
              &larr; Back to ClearSeg
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 style={{ color: '#1B2B4B', fontSize: 24, fontWeight: 700, marginBottom: 12 }}>Something went wrong</h1>
            <p style={{ color: '#64748B', fontSize: 15, lineHeight: 1.6 }}>
              Please try again or contact us at info@clearseg.com to be removed from our mailing list.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
